exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".XfogcJOjMkmH7UdGU6hCi ._3zvp6RFR7c5D5tUwOR4Mbw{background:#f5f5f5;padding:20px;margin:0 0 30px 0;position:relative}\n", ""]);

// Exports
exports.locals = {
	"Lists": "XfogcJOjMkmH7UdGU6hCi",
	"demoBox": "_3zvp6RFR7c5D5tUwOR4Mbw"
};